import React from "react";
import Logo from "./Logo";
import { Linkedin } from "lucide-react";

const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-white/5 bg-[#060B19] pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-8 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo />
          <p className="mt-5 text-xs uppercase tracking-[0.25em] text-[#5BC4D1] font-medium">
            Fiabilité · Réactivité · Performance
          </p>
          <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-sm">
            Nexodiag accompagne les établissements de santé et les laboratoires
            de biologie médicale dans l&apos;intégration de solutions diagnostiques
            innovantes à forte valeur médicale, clinique et économique.
          </p>
          <div className="mt-6 flex items-center gap-3">
            <a
              href="#"
              data-testid="footer-social-0"
              className="h-10 w-10 rounded-full border border-white/10 flex items-center justify-center text-slate-300 hover:text-[#5BC4D1] hover:border-[#5BC4D1]/40 transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin size={16} />
            </a>
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-5">
            Solution
          </div>
          <ul className="space-y-3 text-sm text-slate-300">
            <li><a href="#services" className="hover:text-[#5BC4D1] transition-colors" data-testid="footer-link-services">Applications</a></li>
            <li><a href="#how-it-works" className="hover:text-[#5BC4D1] transition-colors" data-testid="footer-link-process">Fonctionnement</a></li>
            <li><a href="#about" className="hover:text-[#5BC4D1] transition-colors" data-testid="footer-link-about">À propos</a></li>
            <li><a href="#faq" className="hover:text-[#5BC4D1] transition-colors" data-testid="footer-link-faq">FAQ</a></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-5">
            Légal
          </div>
          <ul className="space-y-3 text-sm text-slate-300">
            <li><a href="#" className="hover:text-[#5BC4D1] transition-colors" data-testid="footer-link-mentions">Mentions légales</a></li>
            <li><a href="#" className="hover:text-[#5BC4D1] transition-colors" data-testid="footer-link-privacy">Confidentialité</a></li>
            <li><a href="#" className="hover:text-[#5BC4D1] transition-colors" data-testid="footer-link-cookies">Cookies</a></li>
            <li><a href="#" className="hover:text-[#5BC4D1] transition-colors" data-testid="footer-link-cgu">CGU</a></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-5">
            Contact
          </div>
          <ul className="space-y-3 text-sm text-slate-300">
            <li>contact@nexodiag.fr</li>
            <li>www.nexodiag.fr</li>
            <li className="text-slate-400">
              Société française<br />Solutions diagnostiques innovantes
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 max-w-7xl mx-auto px-6 md:px-8 border-t border-white/5 pt-8 flex flex-col md:flex-row items-center justify-between gap-3">
        <p className="text-xs text-slate-500 tracking-wide">
          © {new Date().getFullYear()} Nexodiag. Tous droits réservés.
        </p>
        <p className="text-xs text-slate-500 tracking-wide text-center md:text-right">
          MeMed Key® et MeMed BV® sont des marques déposées de MeMed. Dispositifs
          destinés à des professionnels de santé.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
